import { FormGroup, FormBuilder, Validators, ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";
import { M_STORE_USER_TIME } from "./M_STORE_USER_TIME";

export class M_STORE_USER {

    addR_DTL: string | null = null;
    addr: string | null = null;

    emP_AUTH: string | null = null;
    emP_AUTH_NM: string | null = null;

    emP_NO: string = '';
    emP_TP: string | null = null;
    emP_TP_NM: string | null = null;

    email: string | null = null;

    hQ_CD: string = '';
    hR_DT: Date | null = null;

    password: string | null = null;

    posT_NO: string | null = null;

    remark: string | null = null;

    retirE_DT: Date | null = null;
    retirE_FG: string | null = null;
    retirE_FG_NM: string | null = null;

    stR_CD: string = '';

    teL_NO: string | null = null;

    useR_ID: string = '';
    useR_NM: string = '';
    workHours = new Array<M_STORE_USER_TIME>();

    constructor(init?: Partial<M_STORE_USER>) {
        Object.assign(this, init);
    }

    /* =======================
        Convert trước khi gửi API
    ======================== */
    toJSON(): any {
        const obj: any = {};

        Object.keys(this).forEach(key => {
            const value = (this as any)[key];

            if ((key === 'hR_DT' || key === 'retirE_DT') && value) {
                obj[key] = this.formatDate(value);
            }
            else if (key === 'teL_NO' && value) {
                obj[key] = value.replaceAll('-', '');
            }
            else {
                obj[key] = value ?? null;
            }
        });

        return obj;
    }

    /* =======================
        Convert từ API về
    ======================== */
    fromJSON(json: any): M_STORE_USER {
        return new M_STORE_USER(json);
    }

    getAllEmployees(res: any[]): M_STORE_USER[] {
        return (res ?? []).map(item => {

            if (item.hR_DT) {
                item.hR_DT = this.parseYYYYMMDD(item.hR_DT);
            }

            item.password = '**********';

            if (item.retirE_DT) {
                item.retirE_DT = this.parseYYYYMMDD(item.retirE_DT);
            }

            if (item.teL_NO) {
                item.teL_NO = this.formatPhone(item.teL_NO);
            }

            return new M_STORE_USER(item);
        });
    }

    getEmployee(res: any): M_STORE_USER | null {
        if (!res) return null;

        if (res.hR_DT) {
            res.hR_DT = this.parseYYYYMMDD(res.hR_DT);
        }

        if (res.retirE_DT) {
            res.retirE_DT = this.parseYYYYMMDD(res.retirE_DT);
        }

        if (res.teL_NO) {
            res.teL_NO = this.formatPhone(res.teL_NO);
        }

        return new M_STORE_USER(res);
    }

    /* =======================
        Reactive Form
    ======================== */
    createForm(fb: FormBuilder): FormGroup {
        return fb.group(
            {
                addR_DTL: [''],
                addr: [{ value: this.addr, disabled: true }],
                emP_AUTH: [''],
                emP_NO: [{ value: this.emP_NO, disabled: true }],
                emP_TP: [''],
                emP_TP_NM: [''],
                email: ['', [Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)]],
                hQ_CD: [''],
                hR_DT: [''],
                inserT_DT: [''],
                inserT_USER: [''],
                password:[{ value: '**********', disabled: true }],
                posT_NO: [''],
                remark: [''],
                retirE_DT: [''],
                retirE_FG: [''],
                retirE_FG_NM: [''],
                stR_CD: [{ value: this.stR_CD, disabled: true }],
                teL_NO: ['', [Validators.required, this.telValidator]],
                updatE_DT: [''],
                updatE_USER: [''],
                usE_YN: ['Y'],
                useR_AUTH: [''],
                useR_AUTH_NM: [''],
                useR_ID: [
                    '',
                    [
                        Validators.required,
                        Validators.pattern(/^[A-Za-z0-9]+$/),
                        Validators.minLength(3),
                        Validators.maxLength(20)
                    ]
                ],
                useR_NM: ['', [Validators.required, Validators.pattern(/^\S$|^\S.*\S$/)]],
                organizationType: [2]
            },
            {
                validators: [this.addrRequiredValidator()]
            });
    }

    /* =======================
        Helpers
    ======================== */

    addrRequiredValidator(): ValidatorFn {
        return (group: AbstractControl): ValidationErrors | null => {
            const addr = group.getRawValue().addr;
            const addrDtl = group.getRawValue().addR_DTL;
            if (!addr) return null;
            return addrDtl ? null : { addrRequired: true };
        };
    }

    telValidator(control: AbstractControl) {
        const raw = (control.value || '').replace(/-/g, ''); // bỏ dấu -
        if (!/^0\d{9,10}$/.test(raw)) {
            return { invalidTel: true };
        }
        return null;
    }

    private formatDate(date: Date): string {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}${month}${day}`;
    }

    private parseYYYYMMDD(value: string | number): Date | null {
        if (!value) return null;

        const str = value.toString();
        if (str.length !== 8) return null;

        const year = Number(str.substring(0, 4));
        const month = Number(str.substring(4, 6)) - 1;
        const day = Number(str.substring(6, 8));

        return new Date(year, month, day);
    }

    private formatPhone(num: string): string {
        const digits = num.replace(/\D/g, '');

        if (digits.length === 10) {
            return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
        }

        if (digits.length === 11) {
            return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`;
        }

        return num;
    }
}